import StripeEmbeddedComponentsRedirectionController from "../../../../../frontend/controllers/payment/stripe_connect/embedded_components/stripe_embedded_components_redirection_controller"
// import { useCompleteCollectionOptions } from "../../../../helpers/stripe_connect/embedded_components/collection_options_helper";

// Connects to data-controller="stripe-embedded-onboarding-component"
export default class extends StripeEmbeddedComponentsRedirectionController {

  connect() {
    // this.componentConfigurations.push(useCompleteCollectionOptions);

    super.connect()
  }

  get componentType() {
    return "account-onboarding";
  }
}
